import Vuex from 'vuex'
import Vue from 'vue'
import {config} from './mock/index.js'
import $ from 'jquery'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isMobile: $(document).width() < 750,
    config: config,
    isEnglish: (name) => {
      let re = /[\u4E00-\u9FA5\uF900-\uFA2D]/
      return !re.test(name)
    },
    isNavClick: false
  },
  mutations: {
    navClick: (state) => {
      state.isNavClick = !state.isNavClick;
    }
  }
})




// WEBPACK FOOTER //
// ./src/store.js